
import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import ProductCurrency from './ProductCurrency';

interface ProductPricingProps {
  price: string;
  setPrice: (price: string) => void;
  reducedPrice: string;
  setReducedPrice: (reducedPrice: string) => void;
  currency: string;
  setCurrency: (currency: string) => void;
}

const ProductPricing = ({ 
  price, 
  setPrice, 
  reducedPrice, 
  setReducedPrice,
  currency,
  setCurrency
}: ProductPricingProps) => {
  // Get currency symbol based on the selected currency
  const getCurrencySymbol = (currencyCode: string) => {
    switch(currencyCode) {
      case 'EUR': return '€';
      case 'USD': return '$';
      case 'GBP': return '£';
      case 'DZD': return 'DA';
      case 'MAD': return 'MAD';
      case 'TND': return 'TND';
      default: return currencyCode;
    }
  };
  
  const currencySymbol = getCurrencySymbol(currency);
  
  return (
    <div className="bg-white dark:bg-[#1e1e2d] rounded-md shadow p-6 border border-gray-200 dark:border-gray-800">
      <h2 className="text-lg font-semibold mb-4 dark:text-gray-200">Tarification</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div>
          <Label htmlFor="price" className="dark:text-gray-300">
            Prix ({currencySymbol})
          </Label>
          <Input 
            id="price" 
            type="number" 
            value={price} 
            onChange={(e) => setPrice(e.target.value)} 
            placeholder="0"
            className="dark:bg-[#151521] dark:border-gray-700 dark:text-gray-200"
          />
        </div>
        <div>
          <Label htmlFor="reducedPrice" className="dark:text-gray-300">
            Prix réduit ({currencySymbol}) <span className="text-gray-400 dark:text-gray-500 text-xs">(facultatif)</span>
          </Label>
          <Input 
            id="reducedPrice" 
            type="number" 
            value={reducedPrice} 
            onChange={(e) => setReducedPrice(e.target.value)} 
            placeholder="Prix réduit ici"
            className="dark:bg-[#151521] dark:border-gray-700 dark:text-gray-200"
          />
        </div>
      </div>
      
      <div>
        <ProductCurrency 
          currency={currency} 
          setCurrency={setCurrency} 
        />
      </div>
    </div>
  );
};

export default ProductPricing;
